
import React from "react";
import { cn } from "@/lib/utils";

interface AnimatedWrapperProps {
  isAnimating: boolean;
  children: React.ReactNode;
  className?: string;
}

const AnimatedWrapper: React.FC<AnimatedWrapperProps> = ({
  isAnimating,
  children,
  className
}) => {
  return (
    <div className={cn(`transition-all duration-300 ${isAnimating ? 'scale-[1.01]' : ''}`, className)}>
      {children}
    </div>
  );
};

export default AnimatedWrapper;
